export enum Temporality {
    PERMANENT = 'PERMANENT', 
    TEMPORARY = 'TEMPORARY'
}